"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.docDetailsStore = void 0;
const zustand_1 = require("zustand");
const middleware_1 = require("zustand/middleware");
const async_storage_1 = require("@react-native-async-storage/async-storage");
exports.docDetailsStore = zustand_1.default(middleware_1.persist((set) => ({
    name: '',
    profileUrl: '',
    email: '',
    setName: (name) => set((state) => (Object.assign(Object.assign({}, state), { name }))),
    setProfileUrl: (profileUrl) => set((state) => (Object.assign(Object.assign({}, state), { profileUrl }))),
    setEmail: (email) => set((state) => (Object.assign(Object.assign({}, state), { email }))),
}), {
    name: 'doc-details-Store',
    getStorage: () => {
        return async_storage_1.default;
    },
}));
//# sourceMappingURL=DoctorDetailsStore.js.map